import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Chips } from './luci-chips.model';

@Component({
  selector: 'luci-chips',
  templateUrl: './luci-chips.component.html',
  styleUrls: ['./luci-chips.component.scss']
})
export class LuciChipsComponent implements OnInit, OnChanges {

  @Input() chips: Chips[] = [];
  @Input() searchQuery;
  @Input() placeholder = '';
  @Input() isNew = false;
  @Input() isRemove = false;

  // tslint:disable-next-line:no-output-native
  @Output() close = new EventEmitter();
  @Output() updateSearch = new EventEmitter();

  constructor() {
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {

  }

  closeTag(tag, index) {
    this.chips.splice(index, 1);
    this.close.emit({tag, index});
  }

}
